import moment from "moment";

export function convertTimestampToDate(timestamp: string | number): Date {
  const normalizedTimestamp = typeof timestamp === "number"
    ? timestamp
    : parseInt(timestamp, 10);

  if (Number.isNaN(normalizedTimestamp)) {
    throw new Error("Invalid timestamp format");
  }
  const isSeconds = Math.abs(normalizedTimestamp) < 1e12;

  const momentDate = isSeconds ? moment.unix(normalizedTimestamp).utc()
    : moment(normalizedTimestamp).utc();

  return momentDate.startOf('day').utc().toDate();
}

export function convertDateToTimestamp(date: string | Date | moment.Moment): number {
  const momentDate = moment(date);

  if(!momentDate.isValid()) {
    throw new Error('Invalid date');
  }

  const normalizedDate = momentDate.utc().startOf('day').unix()
  console.log("Received date is: ", date)
  console.log("The normalized date is:", normalizedDate)
  return normalizedDate;
}
